import { Textarea } from '@/components/ui/textarea';
import { PreVisitQuestionLabel } from './PreVisitQuestionLabel';
import type { PreVisitQuestionRendererProps } from './preVisitQuestionRendererProps';

export function LongTextRenderer({ question, value, isInvalid, onChange }: PreVisitQuestionRendererProps) {
  const resolvedValue = typeof value === 'string' ? value : '';
  const inputId = 'pre-visit-question-' + question.code;

  return (
    <div className="space-y-1.5">
      <PreVisitQuestionLabel question={question} htmlFor={inputId} />
      <Textarea
        id={inputId}
        rows={3}
        className={isInvalid ? 'border-zooerrorborder ring-1 ring-zooerrorborder' : ''}
        value={resolvedValue}
        onChange={function change(changeEvent) {
          onChange(changeEvent.target.value);
        }}
      />
    </div>
  );
}
